import {orderStatusPromisePoller} from '../../api/pollers/pollers';
import DomUtils from '../../utils/DomUtils';
import WeChatApp from '../payment-methods/wechatApp';

const startWeChatPayment = orderJSON => WeChatApp.processWeChatPaymentRequest(orderJSON)
  .then(() => orderStatusPromisePoller.runPoller());

function handleWeChatPayment(orderJSON) {
  if (typeof window.WeixinJSBridge === 'undefined') {
    return DomUtils.waitForEvent('WeixinJSBridgeReady', 20000)
      .then(() => startWeChatPayment(orderJSON));
  }
  return startWeChatPayment(orderJSON);
}

export default {
  handleWeChatPayment,
};
